import { Component, Vue, Prop, Inject, Emit } from 'vue-property-decorator';
import { INoviNsFileUploaderGlobals } from './INoviNsFileUploaderGlobals';
import EventBus from '../../common/services/EventBus';
import FieldValidationErrors from '../../components/errors/FieldValidationErrors.vue';
import File from './File.vue';

declare let noviNs: INoviNsFileUploaderGlobals;

@Component({
    name: 'FileUploader',
    components: {
        FieldValidationErrors,
        File
    },
})
export default class FileUploader extends Vue {
    @Prop({ required: false, default: () => "" })
    value!: string;

    @Prop({ required: false, default: () => "" })
    fileValue!: string;

    @Prop({ required: false, default: () => "bmp|jpe?g|png|ico|pdf|doc?x|xls?x|zip|txt|ppt?x|dwg" })
    extensions!: string;

    @Prop({ required: true })
    customFieldID!: number;

    @Prop({ required: false, default: () => false })
    multiple!: boolean;

    @Prop({ required: false, default: () => 1 })
    fileLimit!: number;

    @Prop({ required: false, default: () => false })
    readOnlyOnFrontend!: boolean;

    @Prop({ required: false, default: () => false })
    readOnlyAfterInitialValue!: boolean;

    @Prop({ required: false, default: () => '' })
    validatorScope!: string;

    @Prop({ required: false, default: () => false })
    isRequired!: boolean;

    @Inject('validator')
    $validator: any;

    @Prop({ required: false, default: () => '' })
    fieldName!: string;

    fileArray: any[] = [];

    mounted() {
        noviNs.mountFileUploader(this.$refs.rootUploaderElement);

        // The code in file-uploader.js populates a hidden input with the new filename
        // Vue doesn't pick up on the change though, so we subscribe to an event that the JS publishes
        var self = this;
        var hiddenFileNameElem = this.$refs.hiddenFileName as HTMLObjectElement;

        var inputName = this.fileInputName;
        hiddenFileNameElem.addEventListener('updateFileName', function (e: any) {
            var inputValues = document.querySelectorAll('input[name="' + inputName + '"]');
            let groupedCustomFieldFiles: any[] = [];
            inputValues.forEach((inputValue: any) => {
                groupedCustomFieldFiles.push(JSON.parse(decodeURIComponent(inputValue.value)));
            });
            self.value = JSON.stringify(groupedCustomFieldFiles);
            self.$emit('input', self.value);
            EventBus.$emit("file-uploaded");
        });

        if (this.fileValue !== null && this.fileValue !== undefined && this.fileValue !== "") {
            if (this.fileValue.startsWith('%')) {
                this.fileValue = decodeURIComponent(this.fileValue);
            }

            this.fileArray = JSON.parse(this.fileValue).map((f: any) => ({
                ...f,
                FileName: f.fileName ?? f.FileName,
                FullPath: this.convertTempFullPath(f.fullPath ?? f.FullPath),
            }));

            this.value = this.fileValue;
        } else {
            this.fileArray = [];
            this.value = "[]";
        }

        self.$emit('input', this.value);
        EventBus.$emit("file-uploaded");
    }

    private convertTempFullPath(fullPath: string): string {
        if (typeof fullPath !== "string") return fullPath;
        if (!fullPath.startsWith("temp/")) return fullPath;

        // Extract file name after the slash
        const fileName = fullPath.substring("temp/".length);

        return `temp?fileName=${fileName}`;
    }

    validateFileRequired(isRequired: boolean) {
        const rules: any = {};

        if (isRequired) {
            rules.requiredFile = true;
        }

        return rules;
    }

    @Emit('input')
    emitInput() {
        return this.value;
    }

    get hasFile() {
        return !!this.value && this.value != '[]';
    }

    get fullFilePath() {
        return this.hasFile ? noviNs.baseFileUrl + this.value : "";
    }

    get fileButtonLabel() {
        if (this.hasFile) {
            return this.multiple ? "Upload Additional Files" : "Replace File";
        } else {
            return this.multiple ? "Upload File(s)" : "Upload File";
        }
    }

    get showFileInput() {
        return !this.readOnlyOnFrontend && (!this.readOnlyAfterInitialValue || !this.hasFile);
    }

    get isParent() {
        return this.validatorScope == 'Company';
    }

    get fileInputName() {
        return (this.validatorScope == 'Company' ? "ParentCustomFieldFile_" : "CustomFieldFile_") + this.customFieldID;
    }

    get customFieldName() {
        return (this.validatorScope == 'Company' ? "Company_CustomField_" : "Person_CustomField_") + this.customFieldID;
    }
}
